import { render, staticRenderFns } from "./StarRatingView.vue?vue&type=template&id=6ec5d100&"
import script from "./StarRatingView.vue?vue&type=script&lang=js&"
export * from "./StarRatingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports